import { CSSObject } from '@chakra-ui/react';
import mascot from '@/assets/oldgill/images/header/dogHorse.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxBallance: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, alpha.700)',
  mx: '1',
  borderBottomRadius: 'base',
  '> div:first-of-type': {
    color: 'beta.400',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
  '> div:last-of-type': {
    color: 'white',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
};

export const buttonDepositProps: CustomButtonProps = {
  variant: 'secondary',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.30)',
  w: 'full',
  mt: '2',
  sx: {
    '&&': {
      _hover: {
        bg: 'beta.600',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.25), 0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
      },
    },
    '& svg': {
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.30)',
      mb: '1',
    },
  },
};

export const ButtonNavItem = (): CSSObject => ({
  bg: 'white',
  color: 'gray.700',
  borderTop: '1px',
  borderColor: 'gamma.200',

  '&& > p': { transition: 'all 0.2s ease-in-out' },
  ':first-child': {
    borderTop: 'none',
  },
  '&:hover, &:active': {
    bg: 'gray.100',
  },
});

export const BoxMascotImage: CSSObject = {
  bgImage: `url(${mascot})`,
  bgSize: 'contain',
  bgPos: 'inherit',
  bgRepeat: 'no-repeat',
  zIndex: '-1',
  display: ['none', null, null, null, 'block'],
  w: '24',
  h: '20',
  pos: 'absolute',
  left: '0',
  top: '-1 ',
};

export const PopoverHeaderQA: CSSObject = {
  bg: 'alpha.500',
  mx: '1',
  mt: '1',
  border: 'none',
  borderTopRadius: 'base',
  pb: '0',
  color: 'white',
  lineHeight: 'normal',
};

export const PopoverContentQA: CSSObject = {
  bg: 'white',
  boxShadow: '2xl',
  _focus: {
    boxShadow: '2xl',
  },
};

export const FlexBallanceItem: CSSObject = {
  color: 'white',

  p: {
    _last: { fontWeight: 'extrabold' },
  },
};

export const TextBalanceValue: CSSObject = {
  color: 'alpha.500',
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: 'sm',
  fontWeight: 'extrabold',
};

export const TextQuickAccessHello: CSSObject = {
  fontSize: 'sm',
};

export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'sm',
  h: 'unset',
};
